const pad = (n) => String(n).padStart(2, '0');

/** Local calendar YYYY-MM-DD (for links / display). */
export const formatDateLocal = (d) =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

const addDays = (d, n) =>
  new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);

/** IST calendar YYYY-MM-DD for reporting APIs (matches Sales drill-down links). */
export function toApiDateString(date) {
  if (!date) return '';
  return formatDateLocal(date);
}

/**
 * Local calendar-day bounds for Player Wise / Show All presets.
 * @param {'Today'|'Yesterday'|'This Week'|'Current Week'|'Last Week'|'This Month'|'Current Month'} filterType
 * @returns {[Date|null, Date|null]}
 */
export function getLocalDateRangeForPlayerWise(filterType) {
  const today = new Date();

  const todayStart = new Date(
    today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0
  );
  const todayEnd = new Date(
    today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999
  );

  switch (filterType) {
    case 'Today':
      return [todayStart, todayEnd];

    case 'Yesterday': {
      const yStart = addDays(todayStart, -1);
      const yEnd = addDays(todayEnd, -1);
      return [yStart, yEnd];
    }

    case 'This Week':
    case 'Current Week': {
      const startOfWeek = addDays(todayStart, -todayStart.getDay());
      return [startOfWeek, todayEnd];
    }

    case 'Last Week': {
      const endOfLastWeek = addDays(todayStart, -todayStart.getDay() - 1);
      const startOfLastWeek = addDays(endOfLastWeek, -6);
      return [startOfLastWeek, endOfLastWeek];
    }

    case 'This Month':
    case 'Current Month': {
      const monthStart = new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0, 0);
      return [monthStart, todayEnd];
    }

    default:
      return [null, null];
  }
}

const GENERIC_PRESET_TO_PLAYER_WISE = {
  today: 'Today',
  yesterday: 'Yesterday',
  currentWeek: 'This Week',
  lastWeek: 'Last Week',
  currentMonth: 'This Month',
};

/**
 * [FromDate, ToDate] for Generic Report presets — aligned with Player Wise Sale Report / Show All.
 * @param {'today'|'yesterday'|'currentWeek'|'lastWeek'|'currentMonth'} preset
 */
export function getApiDateRangeStringsForGenericPreset(preset) {
  const key = GENERIC_PRESET_TO_PLAYER_WISE[preset];
  if (!key) return ['', ''];
  const [start, end] = getLocalDateRangeForPlayerWise(key);
  if (!start || !end) return ['', ''];
  return [toApiDateString(start), toApiDateString(end)];
}
